const base = {
  default: {
    '& > a': {
      '& > img': {
        height: '30px',
        width: '200px'
      }
    }
  }
};

const edu = {
  default: {
    '& > a': {
      '& > img': {
        height: '50px',
        width: '300px'
      }
    }
  }
};

const logo = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu,
    scale: base,
    spark: base
  }
};

export type LogoVariantsType = 'default';
export const logoVariants = Object.keys(base) as LogoVariantsType[];

export default logo;
